var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, html } from '@sick-davinci/ce-decorators';
import { style } from './StatusText.style';
/**
 * A `davinci-status-text` is a textual element that formats the text depending on the type. It is primarily dedicated to visualize status-information of form-elements.
 * This element is designed to work with other input elements like text-area or text-field.
 * If more then one state is defined, the one with higher priority takes precendence.
 * 
 * @example
 * ```html
 *  <davinci-status-text warning>This is a warning-text</davinci-status-text>
 *  ```
 * 
 * @slot {*} default - message-text
 */

export let StatusText = (_dec = Component({
  tag: 'davinci-status-text',
  style: [style],
  dependencies: []
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  type: Boolean
}), _dec7 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class StatusText extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "error", _descriptor, this);

    _initializerDefineProperty(this, "warning", _descriptor2, this);

    _initializerDefineProperty(this, "success", _descriptor3, this);
  }

  render() {
    return html`
    <span class="message">
      <slot></slot>
    </span>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "warning", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "success", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
